<template>
    <div class="d-flex justify-content-end">
      <Button v-if="eventForms.length > 0  && $can(abilities.CAN_CREATE_EVENT_FORM) " btn-class="btn-md" type="new" btn-text="events.forms.new"  @click="handleCreatePress"/>
    </div> 
    <div class="row">
        <div v-if="eventForms.length > 0" class="row g-6 g-xl-9">
            <EventFormCard v-for="element in eventForms" :eventForm="element" :key="element.id" :reload="loadEventForms"/>
        </div> 
        <div v-if="eventForms.length == 0 && !getting">
            <Card class="card p-5 h-full">
                <div class=" text-center ">
                    <div class="pt-8 ">
                    <Img filename="empty.png" alt=""
                        class="mw-100 h-125px h-sm-175px" />
                    </div>
                    <h2 class="fs-2x fw-bolder mb-0">{{ $t('events.forms.noForms') }}</h2>
                    <br>
                    <br>
                    <Button btn-class="btn-md" v-if="$can(abilities.CAN_CREATE_EVENT_FORM)"  type="new" btn-text="events.forms.createNewOne" @click="handleCreatePress"/>
                    <br>
                    <br>
                    <br>
                    <br>
                </div>
            </Card>
        </div>
    </div> 
    <EventFormTypeModal id="kt_chose_form_type"/>   
</template>

<script setup>
import {onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import Button from "@/components/Button.vue";
import Card from "@/components/Card.vue";
import Img from "@/components/Img.vue";
import EventFormCard from "../../components/EventFormCard.vue";
import EventFormTypeModal from "../../components/EventFormTypeModal.vue";
import abilities from "@/composables/abilities";

const route = useRoute()

const store = useStore()

const eventForms = ref([])
const getting = ref(false)

watch(() => route.query.tab, (value) => {
    if(value == 'tab-questions') {
      loadEventForms()
      store.dispatch('forms/getFormTypes')
    }
})

async function loadEventForms() {
  getting.value = true
  await store.dispatch('forms/getEventForms', route.params.id).then((res) => {
    eventForms.value = res?.data?.data
  }).finally(() => {getting.value = false})
} 

const handleCreatePress = () => {
 $("#kt_chose_form_type").modal('toggle')
}

onMounted(async() => {
  if(route.query.tab === 'tab-questions') {
    loadEventForms()
    store.dispatch('forms/getFormTypes')
  }
})

</script>

<style scoped>
  .password-input {
    position: relative;
  }

  .toggle-password {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }

  #eye-icon {
    font-size: 1.2em;
  }
</style>
